import React from "react";
import PropTypes from "prop-types";
import { utils } from "~/utils";
import "./voa_detail.scss";

class VoaDetailList extends React.Component {
    static propTypes = {
        voa: PropTypes.object
    };

    render() {
        const { className, voa } = this.props;
        const header = (
            <nav className="navbar">
                <span className="navbar-brand h4">VOA Information</span>
            </nav>
        );
        this.props.setheader(header);
        return (
            <div {...{ className: ["voa_detail", className].join(" ") }}>
                <div className="content">
                    <div className="row">
                        <div className="col-md-9">
                            <table className="table table-bordered">
                                {voa && (
                                    <thead>
                                        <tr>
                                            <th scope="col">VOA Number</th>
                                            <td>{voa.voa_number}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Vendor Code</th>
                                            <td>{voa.vendor.vendor_number}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Vendor Name</th>
                                            <td>{voa.vendor.legal_name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Document Date</th>
                                            <td>{utils.renderDate(voa.document_date)}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Validity Period End</th>
                                            <td>{utils.renderDate(voa.validity_period_end)}</td>
                                        </tr>
                                    </thead>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VoaDetailList;
